import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { auth } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const isWelcome = params.get("welcome") === "1";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== confirm) return setErr("Passwords do not match.");
    setLoading(true);
    try {
      await auth.resetPassword(token, pw);
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1800);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell" data-testid="reset-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo"><span className="logo-icon">⬡</span><span className="app-name">GovCo<span>.AI</span></span></div>
        <h2>{isWelcome ? "Welcome — set your password" : "Choose a new password"}</h2>
        {isWelcome && !done && (
          <p className="sub" style={{ marginTop: -4 }}>An administrator created your GovCo.AI account. Set a password to sign in.</p>
        )}
        {!token && <div className="err">Missing {isWelcome ? "invite" : "reset"} token.</div>}
        {done ? (
          <div className="alert alert-success" style={{ marginTop: 8 }}>
            <span>✅</span><span>Password set. Redirecting to sign in…</span>
          </div>
        ) : (
          <>
            <label htmlFor="pw">{isWelcome ? "Password" : "New password"}</label>
            <input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required autoComplete="new-password" data-testid="reset-password" />
            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>Min 12 chars with upper, lower, number, special.</div>
            <label htmlFor="confirm">Confirm</label>
            <input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" data-testid="reset-confirm" />
            {err && <div className="err" data-testid="reset-error">{err}</div>}
            <button type="submit" className="btn btn-primary w-full" style={{ justifyContent: "center", marginTop: 16 }} disabled={loading || !token} data-testid="reset-submit">
              {loading ? <span className="spinner white" /> : (isWelcome ? "Set password" : "Update password")}
            </button>
          </>
        )}
        <div style={{ textAlign: "center", marginTop: 14, fontSize: 13 }}>
          <Link to="/login" style={{ color: "var(--primary)", fontWeight: 600 }}>Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
